(ns kyber.kyber-db.hr-manager-report-team-data)

(defn ->ident-key
  [{activity-uuid :activity/uuid manager-uuid :user/uuid}]
  (str "activity-" activity-uuid "_manager-" manager-uuid))

(def model
  {:ident-key ->ident-key})
